import { LoadingSpinner } from "@newsela/angelou";

import NewselaGlobalLayout from "@/base";
import Footer from "@/base/Footer";
import RootProviders from "@/base/RootProviders";
import { USER_FEATURE_FOR_PROMOTED_AT_YOUR_DISTRICT_PAGE } from "@/components/ContentPromotions/constants";
import ErrorPage from "@/errors/ErrorPage";
import NotAllowedError from "@/errors/NotAllowedError";
import useHasFeature from "@/features/useHasFeature";
import PromotedAtYourDistrictContainer from "@/yourContent/PromotedAtYourDistrictContainer";

const PromotedAtYourDistrictPageRoute = () => {
  const [
    hasUserFeatureToAccessPromotedAtYourDistrictPage,
    { loading: isLoading, error: isError },
  ] = useHasFeature(USER_FEATURE_FOR_PROMOTED_AT_YOUR_DISTRICT_PAGE);

  if (isLoading) {
    return <NewselaGlobalLayout mainContents={<LoadingSpinner />} />;
  }

  if (isError) {
    return <NewselaGlobalLayout mainContents={<ErrorPage />} />;
  }

  if (!hasUserFeatureToAccessPromotedAtYourDistrictPage) {
    return <NewselaGlobalLayout mainContents={<NotAllowedError />} />;
  }

  return (
    <NewselaGlobalLayout
      mainContents={
        <>
          <PromotedAtYourDistrictContainer />
          <Footer />
        </>
      }
    />
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default PromotedAtYourDistrictPageRoute;
